import React, { Component } from 'react';
import { cloneElement, toChildArray } from 'preact';
import { initialFetch, fetchPostsArray, postApi } from '../utils';

export default class PostProvider extends Component {
  constructor(props) {
    super(props);

    const { config } = props;
    const preview = config.preview ? 'preview/' : '';
    this.apiURL = `${process.env.REACT_APP_CORE_API_URL}/fanboard/${preview}${config.accountId}/${config.folderId}`;

    this.state = {
      posts: [],
      hashtagImageUrl: null,
      loading: true,
      options: {},
    };
  }

  componentDidMount() {
    const { config } = this.props;
    this.setState({ loading: true });
    this.fetchPosts()
      .then(this.injectCTA)
      .then((response) => {
        this.currentUpdateTime = Date.now();
        this.setState({
          posts: response.posts,
          hashtagImageUrl: response.hashtagImageUrl,
          loading: false,
          options: response.options,
          keywords: response.options,
        });
      })
      .catch(() => {
        this.setState({
          loading: false,
        });
      });
    setInterval(async () => {
      await postApi(`${process.env.REACT_APP_CORE_API_URL}/fanboard/${config.accountId}/pings`, {});
    }, 3600000);
  }

  componentDidUpdate({ count, when }) {
    if (!this.currentUpdateTime) {
      this.currentUpdateTime = when;
    } else if (this.currentUpdateTime < when && count) {
      this.currentUpdateTime = when;
      this.fetchPosts().then((postData) => {
        this.setState({
          posts: postData.posts,
        });
      });
    }
  }

  fetchPosts = async () => {
    const { mediaFilter, postLimit } = this.props;
    const searchParams = new URLSearchParams();

    if (mediaFilter) {
      searchParams.append('postType', mediaFilter);
    }

    if (postLimit) {
      searchParams.append('size', postLimit);
    }

    return initialFetch(this.apiURL, searchParams.toString()).then((response) => {
      const { totalPages, posts, hashtagImageUrl, keywords, options } = response;

      if (postLimit < 30) {
        return {
          posts,
          hashtagImageUrl,
          options,
          keywords,
        };
      }

      return fetchPostsArray(this.apiURL, 2, totalPages, searchParams.toString()).then(
        (morePosts) => {
          return {
            posts: [...posts, ...morePosts],
            hashtagImageUrl,
            options,
            keywords,
          };
        }
      );
    });
  };

  injectCTA = (response) => {
    const { injectCTA } = this.props;
    let finalPosts = [];
    const { hashtagImageUrl } = response;
    if (injectCTA) {
      response.posts.forEach((post, index) => {
        if (
          (index + 1) % (response.options.CTAFrequency || 8) === 0 &&
          response.options.showCTA &&
          hashtagImageUrl
        ) {
          finalPosts.push({
            media: [],
            service: 'cta',
            id: `cta-${index}`,
            stickyImage: encodeURI(`${hashtagImageUrl}&width=800`),
          });
        }
        finalPosts.push(post);
      });
    } else {
      finalPosts = [...response.posts];
    }

    return {
      posts: finalPosts,
      hashtagImageUrl,
      options: response.options,
      keywords: response.keywords,
    };
  };

  removeTextOnly = ({ hashtagImageUrl, posts, options, keywords }) => {
    return {
      posts: posts.filter((p) => p.media.length),
      hashtagImageUrl,
      options,
      keywords,
    };
  };

  handleMediaError = (postId, err) => {
    this.currentUpdateTime = Date.now();
    const { posts } = this.state;
    const newPosts = [];
    posts.forEach((p) => {
      if (postId === p.id) {
        if (p.media[0].video && err?.target?.nodeName === 'VIDEO') {
          newPosts.push({ ...p, media: p.media.map((item) => ({ ...item, video: undefined })) });
        }
      } else {
        newPosts.push(p);
      }
    });

    this.setState({
      posts: newPosts,
    });
  };

  render() {
    const { children: childrenProps } = this.props;
    const { posts, hashtagImageUrl, loading, options, keywords } = this.state;
    const children = toChildArray(childrenProps).map((child) => {
      return cloneElement(child, {
        ...this.props,
        hashtagImageUrl,
        loading,
        options,
        keywords,
        posts,
        updateTime: this.currentUpdateTime,
        onMediaError: this.handleMediaError,
      });
    });

    return <>{children}</>;
  }
}
